import { GraphQLErrors } from '@atlassian/jira-business-graphql-errors';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performPostRequest } from '@atlassian/jira-fetch';
import { QUERY, QUERY_NAME } from './gql';
import type { VersionsForProjectOperationResponse, CalendarReleasesRequest } from './types';

export class ConnectedProjectNotFoundError extends Error {}

export const getReleasesByProject = async (request: CalendarReleasesRequest) => {
	if (!request?.projectAri) {
		return [];
	}
	try {
		const response: VersionsForProjectOperationResponse = await performPostRequest(
			`/gateway/api/graphql?operation=${QUERY_NAME}`,
			{
				body: JSON.stringify({
					query: QUERY,
					variables: {
						projectAri: request.projectAri,
						releaseDateAfter: request.releaseDateBefore.toISOString(),
						releaseDateBefore: request.releaseDateAfter.toISOString(),
						first: 50,
					},
				}),
				headers: {
					'X-ExperimentalApi': 'VersionsForProject',
					'Content-Type': 'application/json',
				},
			},
		);

		if (
			response?.errors?.length === 1 &&
			response.errors?.[0]?.extensions?.classification === 'DataFetchingException'
		) {
			throw new ConnectedProjectNotFoundError();
		}

		if (response.errors != null) {
			throw new GraphQLErrors(response.errors);
		}
		return response?.data?.jira?.versionsForProject?.edges?.map(({ node }) => node);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// Don't fire analytics on ConnectedProjectNotFoundError, just rethrow it so that the controller can remove the project link.
		if (!(error instanceof ConnectedProjectNotFoundError)) {
			fireErrorAnalytics({
				meta: {
					id: QUERY_NAME,
					packageName: 'jiraBusinessCalendar',
					teamName: 'wanjel',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};
